import { Box, Typography, Card, CardContent } from "@mui/material";

function AlertsDashboard({ data, setCategory }) {
    // Start with an object that has all categories set to 0
    let counts = {
        total_alerts: 0,
        missing_demand_data: 0,
        capping_exceeded: 0,
        capping_not_reached: 0,
        low_coverage: 0,
        high_CTR: 0,
        low_CTR: 0,
        no_activity: 0,
        high_fraud_rate: 0,
        high_latency: 0
    };

    // Increment counts based on data
    data.forEach(alert => {
        if (alert.category in counts) {
            counts[alert.category]++;
            counts['total_alerts']++;
        }
    });

    const colors = ['#E0BBE4', '#957DAD', '#D291BC', '#FEC8D8', '#FFDFD3', '#FF9AA2', '#FFB7B2', '#FFDAC1', '#E2F0CB', '#B5EAD7', '#C7CEEA'];

    const totalCount = counts['total_alerts'];

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-around', marginBottom: 4, flexWrap: 'wrap' }}>
            <Card sx={{ minWidth: 200, margin: 2, bgcolor: 'lightgray', cursor: 'pointer' }} onClick={() => setCategory(null)}>
                <CardContent>
                    <Typography variant="h5" component="div">
                        {totalCount}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary">
                        Total alerts
                    </Typography>
                </CardContent>
            </Card>

            {Object.entries(counts).map(([category, count], index) => (
                category !== 'total_alerts' && // Skip total_alerts category for individual boxes
                <Card key={category} sx={{ minWidth: 200, margin: 2, bgcolor: colors[index % colors.length], cursor: 'pointer' }} onClick={() => setCategory(category)}>
                    <CardContent>
                        <Typography variant="h5" component="div">
                            {count}
                        </Typography>
                        <Typography variant="subtitle1" color="text.secondary">
                            {category}
                        </Typography>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
}

export default AlertsDashboard;
